import { ENDPOINT_VERSIONS } from 'src/data/constants/endpoints/_endpoint-versions';

export const TICKET_LINK_IMPORT_CREATE_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/ticket-link-imports/create`;

export const TICKET_LINK_IMPORT_GET_ENDPOINT = (bookingOptionId: string) =>
    `/${ENDPOINT_VERSIONS.V2}/ticket-link-imports/booking-option/${bookingOptionId}`;

export const TICKET_LINK_IMPORT_GET_BY_ID_ENDPOINT = (ticketLinkImportId: string) =>
    `/${ENDPOINT_VERSIONS.V2}/ticket-link-imports/${ticketLinkImportId}`;

export const TICKET_LINK_IMPORT_ROWS_GET_ENDPOINT = (ticketLinkImportId: string) =>
    `/${ENDPOINT_VERSIONS.V2}/ticket-link-imports/${ticketLinkImportId}/rows`;

export const TICKET_LINK_IMPORT_APPLY_ENDPOINT = (ticketLinkImportId: string) =>
    `/${ENDPOINT_VERSIONS.V2}/ticket-link-imports/${ticketLinkImportId}/apply`;

export const TICKET_LINK_IMPORT_ROW_ACCESS_LINK_ENDPOINT = (ticketLinkImportRowId: string) =>
    `/${ENDPOINT_VERSIONS.V2}/ticket-link-imports/rows/${ticketLinkImportRowId}/access-link`;

export const TICKET_LINK_IMPORT_ROW_DUPLICATE_TICKET_ENDPOINT = (ticketLinkImportRowId: string) =>
    `/${ENDPOINT_VERSIONS.V2}/ticket-link-imports/rows/${ticketLinkImportRowId}/duplicate-link`;

export const TICKET_LINK_IMPORT_REMATCH_FAILED_ROWS_ENDPOINT = (ticketLinkImportId: string) =>
    `/${ENDPOINT_VERSIONS.V2}/ticket-link-imports/${ticketLinkImportId}/rematch-failed-rows`;
